import { useRoutes } from "react-router-dom"
import UserRoutes from "./UserRoutes"
import AdminRoutes from "./AdminRoutes"
import OperatorRoutes from "./OperatorRoutes"
import LoginRoutes from "./LoginRoutes"

export default function Routers() {
    return useRoutes([UserRoutes, OperatorRoutes, AdminRoutes, LoginRoutes])
}